import type { Step } from "react-joyride";

export const leaveRequestEditTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຫນ້າແກ້ໄຂຄຳຂໍລາ. ແກ້ໄຂວັນເລີ່ມ–ສິ້ນສຸດ ເຫດຜົນ ແລ້ວບັນທຶກ. ກົດ 'ທົດລອງທົດສອບ' ເພື່ອເລີ່ມທົດສອບການນຳທາງ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="leave-request-edit-back"]',
    content: "ກັບຄືນສູ່ລາຍລະອຽດຄຳຂໍລາ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="leave-request-edit-form"]',
    content: "ແກ້ໄຂວັນລາ ແລະ ເຫດຜົນ ແລ້ວກົດບັນທຶກ.",
    placement: "top",
  },
];
